import { applyMiddleware, combineReducers, createStore } from "redux";
import LeaderboardReducer from "./leaderboardReducer"
import userReducer from "./userReducer";
import restrictedUser from "./restrictedUser";
import thunk from "redux-thunk";

const rootReducer = combineReducers({
  leaderboard: LeaderboardReducer,
  user: userReducer,
  restrict: restrictedUser,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;